import { render } from "./GeneralLedger.vue?vue&type=template&id=36b90172&scoped=true"
import script from "./GeneralLedger.vue?vue&type=script&lang=js"
export * from "./GeneralLedger.vue?vue&type=script&lang=js"

import "./GeneralLedger.vue?vue&type=style&index=0&id=36b90172&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b90172"]])

export default __exports__